/**
 * How search explains a match, shared by the backend that ranks
 * (`services/search/search-ranking.ts` and the repositories' SQL) and the app
 * that lays results out (`paletteSections.ts`), so a tier means the same thing
 * on both sides of the wire. Lower tiers always rank first.
 *
 * The SQL CASE in `artifact.repository.ts` / `project.repository.ts` writes
 * these numbers as literals; change one here and there together.
 */
export const SEARCH_MATCH_TIER = {
    /** The normalized title or file name equals the query. */
    EXACT_NAME: 0,
    /** The normalized name starts with the query (last word still being typed). */
    NAME_PREFIX: 1,
    /** Every query word is in the name. */
    NAME_ALL_WORDS: 2,
    /** Every query word is in the body or an image's description. */
    BODY_ALL_WORDS: 3,
    /** The name is within a typo of the query (trigram similarity). */
    NAME_TYPO: 4,
    /** Only some of the query words matched. */
    SOME_WORDS: 5,
};
/**
 * The words of `text` as search reads them: lowercased, split on anything that
 * is not a letter or a digit. The one spelling of the rule on the TypeScript
 * side; `normalizedSql` in `artifact.repository.ts` is the SQL spelling.
 */
export function searchWords(text) {
    return text
        .toLowerCase()
        .split(/[^\p{L}\p{N}]+/u)
        .filter((word) => word.length > 0);
}
//# sourceMappingURL=searchMatch.js.map